import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { notification } from 'antd';
import { useFilteredColumns } from 'common/ColumnsFilter/use-filtered-columns';
import {
  deleteCurriculum,
  getCurriculums,
  getLastSyncInfo,
  syncCurriculums,
  type Curriculum,
} from 'services/api/educationPlans';
import { getEducationPlanUrl } from 'services/navigation';
import { getColumns } from '../columns';

export const useEducationPlans = () => {
  const navigate = useNavigate();
  const [educationPlans, setEducationPlans] = useState<Curriculum[]>([]);
  const [loading, setLoading] = useState(false);
  const [lastSyncDate, setLastSyncDate] = useState<string>('');
  const [syncInProgress, setSyncInProgress] = useState(false);

  const handleViewEducationPlan = (educationPlanId: number) => {
    navigate(getEducationPlanUrl({ educationPlanId: educationPlanId.toString() }));
  };

  const handleCreateEducationPlan = () => {
    navigate(getEducationPlanUrl({ educationPlanId: 'new' }));
  };

  const handleCopyEducationPlan = (educationPlanId: number) => {
    const baseUrl = getEducationPlanUrl({ educationPlanId: 'new' });
    navigate(`${baseUrl}?from=${educationPlanId}`);
  };

  const handleDeleteEducationPlan = (educationPlanId: number) => {
    deleteCurriculum(educationPlanId.toString()).then(() => {
      notification.success({ message: 'Учебный план успешно удален' });
      getCurriculums().then((res) => {
        setEducationPlans(res);
      });
    });
  };
  const columns = getColumns({
    onCopy: handleCopyEducationPlan,
    onDelete: handleDeleteEducationPlan,
  });
  const { filteredColumns, visibleKeys, setVisibleKeys } = useFilteredColumns(columns, ['id']);

  const syncHandler = () => {
    setSyncInProgress(true);
    syncCurriculums()
      .then(({ count, lastSyncDate: lastSyncDateFromResponse }) => {
        notification.success({
          description: `Учебных планов получено из ООП: ${count}`,
          message: 'Успешно',
          duration: 0,
        });
        setLastSyncDate(lastSyncDateFromResponse);
        getCurriculums().then((res) => {
          setEducationPlans(res);
        });
      })
      .finally(() => {
        setSyncInProgress(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    getLastSyncInfo().then((res) => {
      setLastSyncDate(res.lastSyncDate);
    });
    getCurriculums()
      .then((res) => {
        setEducationPlans(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return {
    state: {
      dataSource: educationPlans,
      loading,
      columns,
      filteredColumns,
      visibleKeys,
      lastSyncDate,
      syncInProgress,
    },
    methods: {
      handleViewEducationPlan,
      handleCreateEducationPlan,
      handleCopyEducationPlan,
      syncHandler,
      setVisibleKeys,
    },
  };
};
